<template>
    <div>
        <div id="app" v-if="logged">
            <div class="ns-loading">
                <div class="loading-box">
                    <i class="loading-dot"></i>
                    <i class="loading-dot"></i>
                    <i class="loading-dot"></i>
                </div>
            </div>

            <div id="page-container" class="header-fixed-top sidebar-visible-lg-full enable-cookies">
                <div id="sidebar">
                    <div id="sidebar-brand" class="sidebar-title text-center" style="background-color:#FFFFFF !important;">
                        <div class="sidebar-nav-mini-hide" style="padding-top: 5px;">
                            <!--<img src="/imagens/logo.png" alt="" style="height: 50px; margin-top: -12px;"/>-->
                            <img src="" id="logoMarca" alt="" style="height: 50px; margin-top: -12px;"/>
                        </div>
                    </div>
                    <div id="sidebar-scroll">
                        <div class="sidebar-content">
                            <ul class="sidebar-nav">
                                <li class="sidebar-separator"><i class="fa fa-ellipsis-h"></i></li>

                                <li>
                                    <router-link :to="{name: 'pessoas'}" style="padding-left:8px">
                                        <i class="fa fa-user sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Pessoas</span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{name: 'analises'}" style="padding-left:8px">
                                        <i class="fas fa-list-ul sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Análises</span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{name: 'analises.documentos'}" style="padding-left:8px">
                                        <i class="fas fa-money-bill-alt sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Documentos emitidos</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'creditoDebito'}" style="padding-left:8px">
                                        <i class="fa fa-list-alt sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Crédito / Débito</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'culturas'}" style="padding-left:8px">
                                        <i class="fab fa-envira sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Culturas</span>
                                    </router-link>
                                </li>
                                <li v-if="$store.state.Auth.user != null && $store.state.Auth.user.permissao_empresa != null && parseInt($store.state.Auth.user.permissao_empresa.conta_receber_manter)">
                                    <router-link :to="{name: 'analises.agrupar'}" style="padding-left:8px">
                                        <i class="far fa-newspaper sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Pagamentos</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'relatorios'}" style="padding-left:8px">
                                        <i class="fa fa-print sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Relatórios</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'envios.embrapa'}" style="padding-left:8px">
                                        <i class="fa fa-cloud sidebar-nav-icon"></i>
                                        <span class="sidebar-nav-mini-hide">Envios Embrapa</span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div id="main-container">
                    <header class="navbar navbar-inverse navbar-fixed-top">
                        <ul class="nav navbar-nav-custom">
                            <li>
                                <a class="base btn-toggle-sidebar" onclick="App.sidebar('toggle-sidebar');this.blur();">
                                    <i class="fa fa-ellipsis-v fa-fw animation-fadeInRight" id="sidebar-toggle-mini"></i>
                                    <i class="fa fa-bars fa-fw animation-fadeInRight" id="sidebar-toggle-full"></i>
                                </a>
                            </li>
                        </ul>

                        <ul class="nav navbar-nav-custom pull-right">
                            <li class="dropdown">
                                <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
                                    <img src="https://app.numerama.com.br/images/user_profile.png" alt="avatar"/>
                                </a>
                                <ul class="dropdown-menu dropdown-menu-right">
                                    <li class="dropdown-header">
                                        <strong class="nome-usuario"> Nome </strong>
                                    </li>
                                    <li v-if="$store.state.Auth.user != null && $store.state.Auth.user.permissao_empresa != null && parseInt($store.state.Auth.user.permissao_empresa.configuracao)">
                                        <router-link :to="{name: 'configuracao'}">
                                            <i class="fa fa-cogs fa-fw pull-right"></i>
                                            Configurações
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name: 'logout'}">
                                            <i class="fa fa-power-off fa-fw pull-right"></i>
                                            Sair
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </header>

                    <div id="page-content">
                        <div class="content-header">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="header-section">
                                        <h1>{{ title }}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="mensagem-aviso">
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="app" v-else-if="!logged">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import app from '@/assets/js/app'

    export default {
        updated: function () {
            this.$nextTick(function () {
                window.App = app
                app.init()
            })
        },
        computed: {
            title() {
                return this.$store.state.App.title
            },
            logged() {
                return this.$store.state.Auth.check
            }
        },
        methods: {
            logout() {
                this.$store.dispatch('logout');
                this.$router.push({name: 'login'});
            },

            getLogo() {
                if ($('#logoMarca').attr('src') == '') {
                    this.$http.post('api/getLogo').then((response) => {
                        $('#logoMarca').attr('src', 'data:image/jpeg;charset=utf-8;base64,' + response.data.logo)
                    });
                }
            }
        },
        mounted() {
            const self = this

            if (!self.logged) {
                return self.$router.push({name: 'login'})
            }
            setTimeout(function () {
                self.getLogo()
            }, 500)
        }
    }
</script>

<style lang="scss">

    @import './src/assets/css/app.scss';

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
        a {
            font-weight: bold;
            color: #2c3e50;
            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .swal2-popup .swal2-title {
        font-size: 18px !important;
    }

    .swal2-popup .swal2-content {
        font-size: 15px !important;
        margin-bottom: 15px !important;
        line-height: 150% !important;
    }

    .swal2-popup .swal2-title {
        margin: 5px 0 1.4em !important;
    }

    .swal2-confirm {
        font-size: 12px !important;
        background-color: #afde5c !important;
        border-left-color: #afde5c !important;
        border-right-color: #afde5c !important;
        box-shadow: none !important;
    }

    .swal2-cancel {
        font-size: 12px !important;
        background-color: #de815c !important;
        border-left-color: #de815c !important;
        border-right-color: #de815c !important;
        box-shadow: none !important;
    }

    .swal2-popup .swal2-input, .swal2-popup .swal2-file, .swal2-popup .swal2-textarea, .swal2-popup .swal2-select, .swal2-popup .swal2-radio, .swal2-popup .swal2-checkbox {
        margin: 20px auto -10px auto !important;
    }

    .swal2-actions * {
        font-size: 13px !important;
    }

    .dropdown-toggle {
        height: 35px !important;
    }

    .dropdown-toggle .clear {
        visibility: hidden;
    }

    .v-select.searchable .dropdown-toggle {
        cursor: text;
        background: white;
    }

    //corrige bug do select quando está desativado
    .dropdown.v-select.single.searchable.disabled input[type=search] {
        display: none;
    }

    .table thead > tr > th, .table thead > tr > td {
        font-size: 14px !important;
    }
</style>
